import { Api as API } from '../../config/apiCallDispatcher';
import { createTestConnectionsProfile } from '../../features/connections/testData';
import { ConnectionsProfile, GetAllExpertProfilesResponse } from './types';

export const getAllConnectionsProfiles = async (): Promise<ConnectionsProfile[]> => {
    const useReal = true;

    if (useReal) {
        const BATCH_SIZE = 50;
        const allProfiles: ConnectionsProfile[] = [];
        let pageIndex = 0;
        let reachedEnd = false;
        while (reachedEnd === false) {
            const apiResponse = await API.get(`expert`, `profiles/list?batchSize=${BATCH_SIZE}&page=${pageIndex}`);
            const response = apiResponse.data as GetAllExpertProfilesResponse;
            if (response) {
                const profilesBatch = response as ConnectionsProfile[];
                allProfiles.push(...profilesBatch);
                if (profilesBatch.length < BATCH_SIZE) {
                    reachedEnd = true;
                } else {
                    pageIndex++;
                }
            } else {
                reachedEnd = true;
            }
        }

        return allProfiles;
    } else {
        return [
            createTestConnectionsProfile({
                expertId: '1',
                title: 'Dr',
                firstName: 'Doofen',
                lastName: 'Schmirtz',
                jobTitle: 'Cognitive Behavioural Therapist',
            }),
            createTestConnectionsProfile({
                expertId: '96b00ae5-0487-4121-ad3d-698ed687c475', // Hannah
                title: 'Dr',
                firstName: 'Arthur',
                lastName: 'Dent',
                jobTitle: 'Psychiatrist',
            }),
            // extend as needed
        ];
    }
};
